import { render, staticRenderFns } from "./backoffice-producao.vue?vue&type=template&id=619e5574&scoped=true"
import script from "./backoffice-producao.vue?vue&type=script&lang=ts"
export * from "./backoffice-producao.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-producao.vue?vue&type=style&index=0&id=619e5574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619e5574",
  null
  
)

export default component.exports